import { Typography, Row, Col, Card } from 'antd';
import {
    FileText, Link, Cloud, Shield,
    Code, Table, FolderTree, Moon
} from 'lucide-react';

const { Title, Paragraph } = Typography;

const featuresList = [
    {
        icon: <FileText size={32} color="#fbbf24" />,
        title: "Multiple Notes Per Page",
        description: "Create unlimited notes for any single page using our tabbed interface. Perfect for separating research topics, pros/cons lists, or section-specific notes."
    },
    {
        icon: <Link size={32} color="#818cf8" />,
        title: "Smart URL Intelligence",
        description: "We strip tracking codes and session IDs automatically. Notes stick to the actual content (e.g., specific Amazon products or YouTube videos), not messy URLs."
    },
    {
        icon: <Code size={32} color="#34d399" />,
        title: "Developer-Ready Editor",
        description: "First-class support for code blocks with syntax highlighting for 30+ languages, including JS, Python, Go, and Rust."
    },
    {
        icon: <Table size={32} color="#f472b6" />,
        title: "Tables & Data",
        description: "Insert fully editable tables for comparisons and structured data. Copy-paste compatible from Excel or other web tables."
    },
    {
        icon: <Cloud size={32} color="#60a5fa" />,
        title: "Seamless Cloud Sync",
        description: "Sign in with Google to sync notes across Chrome, Firefox, Edge, and Mobile. Works offline and syncs when you reconnect."
    },
    {
        icon: <Shield size={32} color="#fbbf24" />,
        title: "End-to-End Encryption",
        description: "Your notes are encrypted on your device before they touch our servers. Zero knowledge — we cannot read your thoughts."
    },
    {
        icon: <FolderTree size={32} color="#a78bfa" />,
        title: "Folders & Tags",
        description: "Organize notes with folders and color-coded tags. Filter and find what you need instantly. Perfect for keeping projects separated and searchable."
    },
    {
        icon: <Moon size={32} color="#94a3b8" />,
        title: "Beautiful Themes",
        description: "Choose from Light Mode, Dark Mode, or the developer-favorite Dracula theme. Designed to be easy on the eyes."
    }
];

export default function FeaturesSection() {
    return (
        <div className="section features-section" id="features">
            <div className="section-container">
                <div className="section-header">
                    <Title level={2}>Every Feature You Need</Title>
                    <Paragraph className="section-subtitle">
                        Packed with power user features designed to make you smarter, faster, and more organized.
                    </Paragraph>
                </div>

                <Row gutter={[32, 32]}>
                    {featuresList.map((f, i) => (
                        <Col xs={24} md={12} key={i}>
                            <Card className="feature-card" bordered={false} style={{ height: '100%' }}>
                                <div style={{ display: 'flex', gap: 20 }}>
                                    <div style={{
                                        minWidth: 60, height: 60,
                                        background: 'rgba(255,255,255,0.05)',
                                        borderRadius: 12, display: 'flex',
                                        alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        {f.icon}
                                    </div>
                                    <div>
                                        <Title level={4} style={{ marginTop: 0, marginBottom: 8, color: 'var(--text-primary)' }}>{f.title}</Title>
                                        <Paragraph style={{ fontSize: 16, color: 'var(--text-secondary)' }}>
                                            {f.description}
                                        </Paragraph>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
}
